<script>
  import Icon from "./helpers/Icon.svelte";
  import Range from "./helpers/Range.svelte";
  import copy from "../data/doc.json";
  import { selectedAudience, audienceOpen, adOpen } from "../stores/global.js";
  import fx from "../utils/fx.js";
  import afx from "../actions/fx.js";

  let activeOption = 0;

  let value = 0;
  let label = "All";

  const options = copy.audienceOptions;

  const width = options.length * 48;

  const toggle = () => {
    $audienceOpen = !$audienceOpen;
  };

  const updateActive = (i) => {
    activeOption = i;
    $selectedAudience = options[i];
  };

  $: $selectedAudience = label;
  $: if ($selectedAudience !== "All") fx("up");
</script>

<div id="audience">
  <p>{copy.audienceOverline}</p>
  <Range
    width="{width}"
    ticks="{options}"
    orientation="vertical"
    step="{1}"
    min="{0}"
    max="{options.length - 1}"
    bind:value
    bind:label
  />
</div>

<div id="audience-mobile" class:open="{$audienceOpen}" class:hide="{$adOpen}">
  <div class="inner">
    <p class="title">{copy.audienceOverline}</p>
    <div class="options">
      {#each options as name, i}
        <div class="option" class:active="{i === activeOption}">
          <button on:click="{() => updateActive(i)}">{name}</button>
        </div>
      {/each}
    </div>
  </div>
  <div class="outer">
    <button class="show icon" on:click="{toggle}" use:afx
      >{@html copy.audienceTease}
      <span><Icon stroke-width="1px" name="crosshair" /></span></button
    >
    <button class="hide icon" on:click="{toggle}" use:afx
      ><span><Icon stroke-width="1px" name="x" /></span></button
    >
  </div>
</div>

<style>
  #audience {
    position: absolute;
    bottom: 0.5em;
    left: 50%;
    transform-origin: 0 0;
    transform: translate(-50%, 0);
    /* transform: rotate(-90deg) translate(0, -3em); */
  }

  #audience p {
    margin-bottom: 3em;
    font-size: 12px;
    text-transform: uppercase;
    font-weight: bold;
  }

  #audience-mobile {
    display: none;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    pointer-events: auto;
    transform: translate(0, 100%);
    transition: transform 250ms ease-out;
    z-index: var(--z-top);
  }

  #audience-mobile.open {
    transform: translate(0, 0);
  }

  #audience-mobile.hide button.show {
    opacity: 0;
    pointer-events: none;
  }

  p.title {
    text-transform: uppercase;
    font-size: 12px;
    font-weight: bold;
    position: absolute;
    top: 0;
    left: 1em;
    margin: 0;
    transform: translate(0, 0);
    transition: all 250ms ease-out;
  }

  .open p.title {
    transform: translate(0, -150%);
  }

  button {
    margin: 0;
    line-height: 1.2;
    display: flex;
    padding: 0.5em;
    border: 1px dashed currentColor;
    font-size: 12px;
    font-weight: bold;
    color: var(--base-white);
    transition: all 150ms ease-out;
    text-align: center;
    border-radius: 0;
    opacity: 0.75;
    max-width: 14em;
    text-transform: uppercase;
  }

  .options {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    background-color: var(--base-gray-dark);
    padding: 1em 0;
  }

  .option {
    margin-bottom: 1em;
  }

  .option button {
    display: block;
    width: 15em;
    text-align: center;
    font-size: 11px;
    text-align: center;
  }

  .active button {
    color: var(--theme);
    opacity: 1;
  }

  .inner {
    background-color: var(--base-white);
    width: 100%;
    /* box-shadow: 0 0 5px 10px rgba(0, 0, 0, 0.75); */
  }

  .outer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  button.show {
    position: absolute;
    bottom: 100%;
    right: 1.25em;
    pointer-events: auto;
    border: 1px dashed var(--base-white);
    border-radius: 0;
    width: 8em;
    height: 8em;
    font-size: 12px;
    font-weight: bold;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    padding-top: 1em;
    transition: all 250ms ease-out;
    transform: translate(0, 0);
  }

  button.hide {
    position: absolute;
    bottom: 100%;
    right: 1em;
    pointer-events: auto;
    border: 1px dashed var(--base-white);
    border-radius: 0;
    font-size: 12px;
    font-weight: bold;
    border-radius: 50%;
    width: 3em;
    height: 3em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    opacity: 0;
    pointer-events: none;
    transition: all 250ms ease-out;
    transform: translate(0, -1em);
  }

  button.hide span {
    transform: translate(0, 2px);
  }

  button span {
    display: block;
    margin: 0;
    line-height: 1;
    font-size: 2em;
    transform: translate(0, 4px);
  }

  .open .show {
    opacity: 0;
    pointer-events: none;
  }

  .open .hide {
    opacity: 1;
    pointer-events: auto;
  }

  .title {
    margin: 0;
  }

  @media only screen and (max-width: 640px) {
    #audience {
      display: none;
    }

    #audience-mobile {
      display: block;
    }

    button.show {
      /* bottom: auto; */
      right: 2.5em;
      transform: translate(0, -40%);
    }
  }
</style>
